export enum PoiAccessTypeEnum {
    AIRPORT = 'airport',
    BOAT = 'boat',
    BUS_STATION = 'busStation',
    EVENT = 'event',
    FUNICULAR_STATION = 'funicularStation',
    PARKING = 'parking',
    SHUTTLE_STATION = 'shuttleStation',
    SUBWAY = 'subway',
    TAXI = 'taxi',
    TOURIST_OFFICE = 'touristOffice',
    TRAIN_STATION = 'trainStation',
}
